import { useCallback, useEffect, useState, useRef } from "react";
import { PaylistTransactionDataAction } from "../../Actions/PaycentralAction";
import {
  MyReceiptLongIcon,
  MyRefreshIcon,
  MyTaskAltIcon,
  MyDoNotDisturbOnIcon,
} from "../../Assets/svg/MyIcons";

const StatCard = ({ title, amount, icon: Icon, color, loading, colClass }) => {
  const count = amount?.count ?? amount ?? 0;
  const hasAmount = amount?.amount !== undefined;
  const amt = hasAmount ? Number(amount.amount || 0).toFixed(2) : null;

  return (
    <div className={colClass}>
      <div className="card h-100 shadow-sm rounded-3">
        {loading ? (
          <div className="d-flex align-items-center justify-content-center p-10">
            <div className="spinner-border text-primary" role="status" style={{ width: 32, height: 32 }} />
          </div>
        ) : (
          <div className="card-body d-flex flex-column p-5">

            {/* Icon + Numbers Row */}
            <div className="d-flex justify-content-between align-items-start mb-3">
              {/* Left: Icon */}
              <div
                className="symbol w-55px h-55px d-flex justify-content-center align-items-center rounded-circle border flex-shrink-0"
                style={{
                  backgroundColor: `${color}20`,
                  borderColor: `${color}40`,
                  color,
                }}
              >
                <Icon size={28} />
              </div>

              {/* Right: Count on top, Amount below */}
              <div className="text-end">
                {/* COUNT - Big */}
                <div
                  style={{
                    fontSize: "34px",
                    fontWeight: "700",
                    color: "#1e3a8a",
                    lineHeight: "1",
                  }}
                >
                  {count}
                </div>

                {/* AMOUNT - Directly below count */}
                {hasAmount && (
                  <div
                    style={{
                      fontSize: "19px",
                      fontWeight: "600",
                      color: "#000",
                      marginTop: "2px",
                    }}
                  >
                    {amt}
                  </div>
                )}
              </div>
            </div>

            {/* Title at the bottom */}
            <div className="mt-auto fw-semibold text-gray-600 fs-5 pt-2">
              {title}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const PaycentralTransactionCards = ({
  handleSnackBar = () => { },
  startDate,
  endDate,
  statusFilter,
  tenantDb,
  searchValue,
  amountFilter,
  shouldRefresh = 0,
}) => {
  const [loading, setLoading] = useState(false);

  const [stats, setStats] = useState({
    totalCount: 0,

    offlineCount: 0,
    offlineAmount: 0,

    successCount: 0,
    successAmount: 0,

    pendingCount: 0,
    pendingAmount: 0,
  });

  const safeNum = useCallback((val, fallback = 0) => {
    if (val == null) return fallback;
    const num = Number(val);
    return isNaN(num) ? fallback : num;
  }, []);

  // ✅ NEW MAPPING (ONLY 4 FEES)
  const mapSummaryToStats = useCallback((summary = {}) => {
    return {
      oneTimeSetupFee: safeNum(summary.oneTimeSetupFee),
      ongoingMaintenanceFee: safeNum(summary.ongoingMaintenanceFee),
      newMerchantSetupFee: safeNum(summary.newMerchantSetupFee),
      ongoingMaintenancePerMerchantFee: safeNum(summary.ongoingMaintenancePerMerchantFee),
    };
  }, [safeNum]);
  const firstRender = useRef(true);


  const fetchSummary = async () => {


    setLoading(true);

    try {
      const res = await PaylistTransactionDataAction(
        10,
        1,
        statusFilter,
        tenantDb !== "all" ? tenantDb : null,
        startDate,
        endDate,
        searchValue
      );

      const dashboard = res?.data?.data?.dashboardStats;

      setStats({
        totalCount: res?.data?.data?.totalCount || 0,

        offlineCount: dashboard?.offline?.count || 0,
        offlineAmount: dashboard?.offline?.amount || 0,

        successCount: dashboard?.success?.count || 0,
        successAmount: dashboard?.success?.amount || 0,

        pendingCount: dashboard?.pending?.count || 0,
        pendingAmount: dashboard?.pending?.amount || 0,
      });

    } catch (error) {
      console.error("❌ KPI FETCH ERROR:", error);
      handleSnackBar("error", "Failed to load summary");
    } finally {
      setLoading(false);
    }
  };






  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    if (shouldRefresh <= 0) return;

    fetchSummary();
  }, [shouldRefresh]);




  // ✅ ONLY 4 KPI CARDS
  const cards = [
    {
      title: "Offline Transactions",
      amount: {
        count: stats.offlineCount,
        amount: stats.offlineAmount,
      },
      icon: MyRefreshIcon,
      color: "#10b981",
      colClass: "col-12 col-sm-6 col-lg-3 mb-4",
    },
    {
      title: "Success Transactions",
      amount: {
        count: stats.successCount,
        amount: stats.successAmount,
      },
      icon: MyTaskAltIcon,
      color: "#22c55e",
      colClass: "col-12 col-sm-6 col-lg-3 mb-4",
    },
    {
      title: "Pending Transactions",
      amount: {
        count: stats.pendingCount,
        amount: stats.pendingAmount,
      },
      icon: MyDoNotDisturbOnIcon,
      color: "#ef4444",
      colClass: "col-12 col-sm-6 col-lg-3 mb-4",
    },
    {
      title: "Total Transactions",
      amount: {
        count: stats.totalCount,
        amount: null,
      },
      icon: MyReceiptLongIcon,
      color: "#6366f1",
      colClass: "col-12 col-sm-6 col-lg-3 mb-4",
    },
  ];

  return (
    <div className="row g-4 mb-5">
      {cards.map((card, idx) => (
        <StatCard key={idx} {...card} loading={loading} />
      ))}
    </div>
  );
};

export default PaycentralTransactionCards;